<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    class="polyline-icon"
  >
    <polyline points="2.98 4.5 13 5 15 13.5" />
    <circle
      cx="3"
      cy="4.5"
      r="2"
    />
    <circle
      cx="15"
      cy="13.5"
      r="2"
    />
    <circle
      cx="13"
      cy="5"
      r="2"
    />
  </svg>
</template>

<script>
export default {
  name: 'PolylineIcon',
};
</script>

<style scoped lang="scss">
.polyline-icon > polyline {
  fill: none;
  stroke: var(--feature-color, main.$npGray);
}
.polyline-icon > circle {
  stroke: var(--feature-color, main.$npGray);
  stroke-miterlimit: 10;
  fill: #fff;
}
</style>
